<template>
  <div class="empty-placeholder-container">
    <div class="empty-placeholder-icon">
      <info-icon class="svg-icon has-fill-primary"></info-icon>
    </div>
    <div class="empty-placeholder-text">
      {{ $t("moderator.no_updates_yet_placeholder") }}
    </div>
    <b-button type="is-primary" class="button mt-2" @click="$emit('start')">
      {{ $t("moderator.start_creating_content_update_button") }}
    </b-button>
  </div>
</template>

<script>
import InfoIcon from "@/assets/icons/info.svg";

export default {
  name: "EmptyExhibitorUpdatesPlaceholder",
  components: { InfoIcon },
};
</script>

<style scoped></style>
